module.exports = __webpack_public_path__ + "media/components/Pages/Home/hero-13fa485cf228a2fd10a0401689d45743.png";